import { LogLevel } from "angular-auth-oidc-client";

const host  = window.location.protocol+'//'+window.location.host;
const launchpadApi = host+'/api/portal/';

export const environmentBase = {
  appName: 'launchpad',
  homeUrl: host+'/portal/home',
  loginUrl : host+'/ids/',
  launchpadGraphEndpoint : launchpadApi+'/graphql/',
  launchpadApi : launchpadApi,
  cookieDomain: window.location.host,
  timeoutInMins: 30,
  impersonationEnabled: true,
  languageSelectorEnabled: true,
  loggingEnabled: true,
  authSettings: {
    secureRoutes: [launchpadApi],
    authority: host+'/ids',
    redirectUrl: host+'/portal/callback',
    clientId: 'LaunchPad_id',
    scope: 'openid profile email offline_access IdentityServerApi ' +
      'launchpad-scope administration-scope cms-scope clientportal-nl-companies-scope',
    logLevel:  LogLevel.Debug,
    cacheTimeInSeconds: 60
  },
  recaptcha: {
    siteKey: '6LdfNCYsAAAAABrty9bc--A-Sxha9rehIpVebzO9'
  }
};
